import GuestsSelector from './GuestsSelector';

export default GuestsSelector;
